import logo from './logo.svg';
import './App.css';
import Navbar from './components/navbar/Navbar';
// import Routes from './Routes'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Footer from './components/footer/Footer';
import ScrollToTop from './dataHelper/ScrollToTop';
import {
  Home,
  Profile,
  Kontak,
  Laporan,
  Gallery,
  Berita,
} from "./components/index";


function App() {
  return (
    <Router>
      <ScrollToTop>
        <Navbar />
        <Switch>
          <Route path='/profile' component={Profile} />
          <Route path='/kontak' component={Kontak} />
          <Route path='/laporan' component={Laporan} />
          <Route path='/berita' component={Berita} />
          <Route path='/gallery' component={Gallery} />
          <Route path='/' component={Home}>
            {/* <Home /> */}
          </Route>
          {/* <Routes /> */}
        </Switch>
        <Footer />
      </ScrollToTop>
    </Router>
  );
}

export default App;
